(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maroysa-lumo-categories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maroysa-lumo-categories')) {
    class MaroysaLumoCategories extends HTMLElement {
      connectedCallback() {
        const items = Array.from(this.querySelectorAll('[data-reveal]'));
        this.classList.add('is-motion-ready');
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
          items.forEach((item) => item.classList.add('is-revealed'));
          return;
        }
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            this.observer.unobserve(entry.target);
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
        items.forEach((item) => this.observer.observe(item));
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    }
    customElements.define('maroysa-lumo-categories', MaroysaLumoCategories);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maroysa-lumo-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maroysa-lumo-hero')) {
    class MaroysaLumoHero extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.counter = this.querySelector('[data-counter]');
        this.progress = this.querySelector('[data-progress]');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.index = 0;
        this.classList.add('is-motion-ready');
        this.updateActiveSlide();
        requestAnimationFrame(() => this.classList.add('is-loaded'));
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.move(-1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.move(1, true));
        this.startAutoplay();
        this.setupHeaderState();
      }
      disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        if (this.onScroll) {
          window.removeEventListener('scroll', this.onScroll);
          this.scroller?.removeEventListener('scroll', this.onScroll);
        }
        document.body.classList.remove('lumo-header-stuck');
      }
      startAutoplay() {
        if (this.dataset.autoplay !== 'true' || this.reducedMotion || this.slides.length < 2) return;
        this.timer = setInterval(() => this.move(1), Number(this.dataset.speed) || 6000);
      }
      /* Collapses the floating header pill into a flush bar once the page leaves the top.
         Desktop scrolls .page-wrapper rather than the window, so watch both. */
      setupHeaderState() {
        this.scroller = document.querySelector('.page-wrapper');
        this.onScroll = () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            const top = Math.max(window.scrollY || 0, this.scroller?.scrollTop || 0);
            document.body.classList.toggle('lumo-header-stuck', top > 24);
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.scroller?.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }
      move(direction, fromUser) {
        if (this.slides.length < 2) return;
        this.index = (this.index + direction + this.slides.length) % this.slides.length;
        this.updateActiveSlide();
        this.track.scrollTo({ left: this.slides[this.index].offsetLeft, behavior: this.reducedMotion ? 'auto' : 'smooth' });
        if (this.counter) this.counter.textContent = `${this.index + 1} / ${this.slides.length}`;
        // Don't let autoplay fire immediately after a manual nudge.
        if (fromUser && this.timer) { clearInterval(this.timer); this.startAutoplay(); }
      }
      updateActiveSlide() {
        this.slides.forEach((slide, index) => slide.classList.toggle('is-active', index === this.index));
        if (this.progress) this.progress.style.transform = `scaleX(${(this.index + 1) / (this.slides.length || 1)})`;
      }
    }
    customElements.define('maroysa-lumo-hero', MaroysaLumoHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maroysa-lumo-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maroysa-lumo-home')) {
    class MaroysaLumoHome extends HTMLElement {
      connectedCallback() {
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.querySelectorAll('[data-tab]').forEach((tab) => tab.addEventListener('click', () => this.selectTab(tab)));
        this.setupMotion();
        this.setupCarousels();
      }
      disconnectedCallback() {
        this.revealObserver?.disconnect();
        this.resizeObserver?.disconnect();
        if (this.onResize) window.removeEventListener('resize', this.onResize);
      }
      setupMotion() {
        const items = Array.from(this.querySelectorAll('[data-reveal]'));
        this.classList.add('is-motion-ready');
        if (this.reducedMotion || !('IntersectionObserver' in window)) {
          items.forEach((item) => item.classList.add('is-revealed'));
          return;
        }
        this.revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            this.revealObserver.unobserve(entry.target);
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
        items.forEach((item) => this.revealObserver.observe(item));
      }
      setupCarousels() {
        this.carousels = Array.from(this.querySelectorAll('[data-carousel]'));
        this.carousels.forEach((carousel) => {
          const track = carousel.querySelector('[data-carousel-track]');
          if (!track) return;
          carousel.track = track;
          carousel.querySelector('[data-carousel-previous]')?.addEventListener('click', () => this.moveCarousel(carousel, -1));
          carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => this.moveCarousel(carousel, 1));
          let frame;
          track.addEventListener('scroll', () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => this.updateCarousel(carousel));
          }, { passive: true });
        });
        this.onResize = () => this.refreshCarousels();
        window.addEventListener('resize', this.onResize, { passive: true });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.refreshCarousels());
          this.carousels.forEach((carousel) => { if (carousel.track) this.resizeObserver.observe(carousel.track); });
        }
        requestAnimationFrame(() => this.refreshCarousels());
      }
      moveCarousel(carousel, direction) {
        if (!carousel.track) return;
        const distance = Math.max(260, carousel.track.clientWidth * 0.78);
        carousel.track.scrollBy({ left: distance * direction, behavior: this.reducedMotion ? 'auto' : 'smooth' });
      }
      updateCarousel(carousel) {
        const track = carousel.track;
        if (!track) return;
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        const position = maximum > 0 ? Math.min(1, Math.max(0, track.scrollLeft / maximum)) : 0;
        const visible = maximum > 0 ? 26 : 100;
        const progress = carousel.querySelector('[data-carousel-progress]');
        if (progress) {
          const translate = visible < 100 ? position * ((100 - visible) / visible) * 100 : 0;
          progress.style.width = `${visible}%`;
          progress.style.transform = `translateX(${translate}%)`;
        }
        const previous = carousel.querySelector('[data-carousel-previous]');
        const next = carousel.querySelector('[data-carousel-next]');
        if (previous) previous.disabled = maximum <= 1 || track.scrollLeft <= 2;
        if (next) next.disabled = maximum <= 1 || track.scrollLeft >= maximum - 2;
      }
      refreshCarousels() { this.carousels?.forEach((carousel) => this.updateCarousel(carousel)); }
      selectTab(tab) {
        this.querySelectorAll('[data-tab]').forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
        this.querySelectorAll('[data-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.panel !== tab.dataset.tab;
          if (!panel.hidden && panel.track) {
            panel.track.scrollTo({ left: 0, behavior: 'auto' });
            requestAnimationFrame(() => this.updateCarousel(panel));
          }
        });
        tab.focus();
      }
    }
    customElements.define('maroysa-lumo-home', MaroysaLumoHome);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maroysa-lumo-new-arrivals"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maroysa-new-arrivals')) {
    class MaroysaNewArrivals extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-new-arrivals-track]');
        this.previous = this.querySelector('[data-new-arrivals-previous]');
        this.next = this.querySelector('[data-new-arrivals-next]');
        this.progress = this.querySelector('[data-new-arrivals-progress]');
        this.prefersReducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

        this.previous?.addEventListener('click', () => this.move(-1));
        this.next?.addEventListener('click', () => this.move(1));

        this.updateBound = () => requestAnimationFrame(() => this.update());
        this.track?.addEventListener('scroll', this.updateBound, { passive: true });

        if ('ResizeObserver' in window && this.track) {
          this.resizeObserver = new ResizeObserver(this.updateBound);
          this.resizeObserver.observe(this.track);
        }

        this.classList.add('is-motion-ready');
        const reveal = this.querySelector('[data-reveal]');
        if (this.prefersReducedMotion.matches || !('IntersectionObserver' in window)) {
          reveal?.classList.add('is-revealed');
        } else if (reveal) {
          this.revealObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-revealed');
              this.revealObserver?.disconnect();
            });
          }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
          this.revealObserver.observe(reveal);
        }

        this.update();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.updateBound);
        this.resizeObserver?.disconnect();
        this.revealObserver?.disconnect();
      }

      move(direction) {
        if (!this.track) return;
        const firstItem = this.track.querySelector('.maroysa-new-arrivals__item');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const distance = (firstItem?.getBoundingClientRect().width || this.track.clientWidth * 0.8) + gap;
        this.track.scrollBy({
          left: direction * distance,
          behavior: this.prefersReducedMotion.matches ? 'auto' : 'smooth'
        });
      }

      update() {
        if (!this.track) return;
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const current = Math.min(maximum, Math.max(0, this.track.scrollLeft));
        const visibleRatio = Math.min(1, this.track.clientWidth / Math.max(1, this.track.scrollWidth));
        const travelRatio = maximum === 0 ? 0 : current / maximum;
        const progressScale = Math.min(1, visibleRatio + travelRatio * (1 - visibleRatio));

        if (this.progress) this.progress.style.transform = 'scaleX(' + progressScale + ')';
        if (this.previous) this.previous.disabled = current <= 1;
        if (this.next) this.next.disabled = current >= maximum - 1;
      }
    }

    customElements.define('maroysa-new-arrivals', MaroysaNewArrivals);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maroysa-product-features"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maroysa-product-features')) {
    customElements.define(
      'maroysa-product-features',
      class extends HTMLElement {
        connectedCallback() {
          this.rows = [...this.querySelectorAll('[data-features-row]')];
          if (!this.rows.length) return;

          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.rows.forEach((row) => {
            if (row.open) row.classList.add('is-open');

            const summary = row.querySelector('summary');
            summary?.addEventListener('click', (event) => {
              event.preventDefault();
              this.toggle(row);
            });
          });

          // Opt into the hidden starting state only now that JS is running, and make
          // sure it is lifted even if the observer never fires.
          this.classList.add('reveal-enabled');
          this.safetyTimer = window.setTimeout(() => this.classList.add('is-visible'), 2500);

          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries[0]?.isIntersecting) return;
              this.classList.add('is-visible');
              this.observer.disconnect();
            },
            { rootMargin: '0px 0px -12% 0px' }
          );
          this.observer.observe(this);

          // The observer never fires if the section is already past the fold on load.
          if (this.getBoundingClientRect().top < window.innerHeight) {
            this.classList.add('is-visible');
          }
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          window.clearTimeout(this.closeTimer);
          window.clearTimeout(this.safetyTimer);
        }

        toggle(row) {
          if (row.classList.contains('is-open')) {
            this.close(row);
            return;
          }

          // Single-open accordion, matching the rest of the theme's disclosures.
          this.rows.forEach((other) => {
            if (other !== row) this.close(other);
          });

          row.open = true;

          /*
           * Force a layout read so the collapsed `0fr` start value is committed before
           * the class flips it to `1fr`. Doing this synchronously rather than in a
           * rAF callback keeps the open state correct even where rAF is throttled or
           * never runs (background tabs, non-compositing embeds).
           */
          void row.querySelector('.maroysa-features__panel')?.offsetHeight;
          row.classList.add('is-open');
        }

        close(row) {
          if (!row.classList.contains('is-open')) return;

          row.classList.remove('is-open');

          if (this.reduceMotion) {
            row.open = false;
            return;
          }

          const panel = row.querySelector('.maroysa-features__panel');
          if (!panel) {
            row.open = false;
            return;
          }

          const finish = () => {
            panel.removeEventListener('transitionend', onEnd);
            window.clearTimeout(row.closeTimer);
            if (!row.classList.contains('is-open')) row.open = false;
          };

          const onEnd = (event) => {
            if (event.propertyName !== 'grid-template-rows') return;
            finish();
          };

          panel.addEventListener('transitionend', onEnd);

          // `transitionend` never fires if the transition is interrupted or never
          // starts, which would strand the row open with its panel collapsed.
          window.clearTimeout(row.closeTimer);
          row.closeTimer = window.setTimeout(finish, 600);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maroysa-startup-popup"]) return;
  try {
    
  if (!customElements.get('maroysa-startup-popup')) {
    customElements.define(
      'maroysa-startup-popup',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-popup-dialog]');
          this.closeButtons = this.querySelectorAll('[data-popup-close]');
          this.form = this.querySelector('form');
          this.email = this.querySelector('.maroysa-startup-popup__email');
          this.delay = Number(this.dataset.delay) || 10000;
          this.storageKey = this.dataset.storageKey;
          this.showOnce = this.dataset.showOnce === 'true';
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.wasOpen = false;
          this.isHiding = false;

          /**
           * The customer form posts and reloads the page, and submitting already wrote the
           * dismissal flag. Reopening here is what lets the subscriber actually see that their
           * code is on the way — or the error, if the address was rejected.
           */
          this.posted = this.querySelector('[data-popup-posted]');
          this.forceOpen = this.posted != null || this.querySelector('[data-popup-errored]') != null;

          if (!this.dialog || (!this.forceOpen && this.shouldSkip())) return;

          this.closeButtons.forEach((button) =>
            button.addEventListener('click', () => this.hide(button.hasAttribute('data-popup-icon-close')))
          );
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.hide();
          });
          this.dialog.addEventListener('cancel', (event) => {
            event.preventDefault();
            this.hide();
          });
          this.form?.addEventListener('submit', () => this.remember());

          if (this.posted) this.applySuccessState();

          this.timer = window.setTimeout(() => this.show(), this.forceOpen ? 400 : this.delay);
        }

        disconnectedCallback() {
          window.clearTimeout(this.timer);
          window.clearTimeout(this.exitTimer);
          window.clearTimeout(this.closeTimer);
          window.clearTimeout(this.copyTimer);
          if (this.wasOpen) this.unlockPage();
        }

        applySuccessState() {
          this.dialog.classList.add('is-success');

          const heading = this.querySelector('[data-popup-success]');
          if (heading && heading.id) this.dialog.setAttribute('aria-labelledby', heading.id);

          const dismiss = this.querySelector('.maroysa-startup-popup__dismiss');
          if (dismiss && dismiss.dataset.successLabel) dismiss.textContent = dismiss.dataset.successLabel;

          const copyButton = this.querySelector('[data-popup-copy]');
          copyButton?.addEventListener('click', () => this.copyCode(copyButton));
        }

        copyCode(button) {
          if (!navigator.clipboard) return;

          const hint = button.querySelector('[data-popup-copy-hint]');

          navigator.clipboard.writeText(button.dataset.popupCopy).then(
            () => {
              if (!hint) return;
              if (!hint.dataset.idleLabel) hint.dataset.idleLabel = hint.textContent;
              hint.textContent = 'Copied';
              window.clearTimeout(this.copyTimer);
              this.copyTimer = window.setTimeout(() => {
                hint.textContent = hint.dataset.idleLabel;
              }, 2000);
            },
            () => {}
          );
        }

        shouldSkip() {
          if (!this.showOnce) return false;

          try {
            return window.sessionStorage.getItem(this.storageKey) === 'dismissed';
          } catch (error) {
            return false;
          }
        }

        remember() {
          if (!this.showOnce) return;

          try {
            window.sessionStorage.setItem(this.storageKey, 'dismissed');
          } catch (error) {
            return;
          }
        }

        show() {
          if (this.dialog.open) return;
          if (!this.forceOpen && this.shouldSkip()) return;

          this.dialog.classList.remove('is-closing');
          this.isHiding = false;
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          this.dialog.showModal();
          this.wasOpen = true;

          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              this.dialog.classList.add('is-visible');
              const focusTarget = this.querySelector('[data-popup-success], [data-popup-errored]') || this.email;
              focusTarget?.focus({ preventScroll: true });
            });
          });
        }

        hide(animateIcon = false) {
          if (!this.dialog.open || this.isHiding) return;

          this.isHiding = true;
          this.remember();
          this.dialog.classList.toggle('is-closing', animateIcon);
          const exitDelay = animateIcon && !this.reduceMotion ? 240 : 0;
          window.clearTimeout(this.exitTimer);
          window.clearTimeout(this.closeTimer);
          this.exitTimer = window.setTimeout(() => {
            this.dialog.classList.remove('is-visible');
            this.closeTimer = window.setTimeout(() => {
              this.dialog.close();
              this.dialog.classList.remove('is-closing');
              this.wasOpen = false;
              this.isHiding = false;
              this.unlockPage();
            }, 560);
          }, exitDelay);
        }

        unlockPage() {
          document.documentElement.style.overflow = this.previousOverflow || '';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
